import classnames from 'classnames';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import Icon, { GLYPHS } from '../../../common/icon';
import NavTooltip from '../../../sidebar/navigation/NavTooltip';

const NavigationButton = ({ active, startTimer, stopTime, collapsed, hover, onMouseIn, onMouseOut }) => {
  const className = classnames('o-icon--pointer', {
    'u-font-color-red': active,
    'u-font-color-primary': !active,
  });
  const handler = active ? stopTime : startTimer;
  const text = active ? 'Clock out' : 'Clock in';

  return (
    <div className="c-user-nav__link" onClick={handler}>
      <span className="c-info-nav-tooltip-handler" onMouseOver={onMouseIn} onMouseOut={onMouseOut}>
        <Icon
          glyph={GLYPHS.stopwatch}
          size="small"
          className={className}
        />
        <div className="c-nav-tooltip">
          <NavTooltip active={hover}>{text}</NavTooltip>
        </div>
        <span className="c-user-nav__text" display-if={!collapsed}>{text}</span>
      </span>
    </div>
  );
};

NavigationButton.propTypes = {
  active: PropTypes.bool.isRequired,
  startTimer: PropTypes.func.isRequired,
  stopTime: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  hover: PropTypes.bool,
  onMouseIn: PropTypes.func,
  onMouseOut: PropTypes.func,
};

NavigationButton.defaultProps = {
  hover: false,
  onMouseIn: noop,
  onMouseOut: noop,
};


export default NavigationButton;
